/* a success/error component to output after each form submission*/

import ReactDOM from "react-dom";
import "./successMessageModal.css";

const PopUpSuccessMessageModal = ({
  successForm,
  showSuccessFormMessage,
  setShowSuccessFormMessage,
}) => {
  const handleCloseSuccessMessage = () => {
    setShowSuccessFormMessage(false);
  };

  const messageModal = (
    <>
      {showSuccessFormMessage && (
        <div
          className={`popup-success-message ${
            successForm === "error" ? "error" : "success"
          }`}
        >
          <button onClick={handleCloseSuccessMessage}>
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div className="success-text">
            {(successForm === "contact" ||
              successForm === "scorecard-contact") && (
              <>
                <span className="highlight-gold">Thank you</span> for reaching
                out! We’ve received your message and will respond shortly. Your
                interest in the{" "}
                <span className="highlight-orange">
                  Catastrophic Wildfire Prevention Consortium (CWPC)
                </span>{" "}
                means a lot to us. In the meantime, feel free to explore our
                ongoing programs on our website.
              </>
            )}
            {(successForm === "sponsor" ||
              successForm === "scorecard-sponsor") && (
              <>
                <span className="highlight-gold">Thank you</span> for your
                interest in sponsorship opportunities with the{" "}
                <span className="highlight-orange">
                  Catastrophic Wildfire Prevention Consortium (CWPC)
                </span>
                . We look forward to collaborating to advance wildfire
                mitigation and resilience, and will connect with you soon.
              </>
            )}
            {(successForm === "subscribe" ||
              successForm === "scorecard-subscribe") && (
              <>
                <span className="highlight-gold">Thank you</span> for
                subscribing to the{" "}
                <span className="highlight-orange">
                  Catastrophic Wildfire Prevention Consortium (CWPC)
                </span>
                . We’re glad to have you with us as we work to advance wildfire
                resilience and prevention. Stay tuned for exciting updates on
                this journey.
              </>
            )}
            {(successForm === "download" ||
              successForm === "scorecard-download") && (
              <>
                <span className="highlight-gold">Thank you</span> for
                downloading! If you have any questions or need support, please
                get in touch with us.
              </>
            )}
            {(successForm === "support" ||
              successForm === "scorecard-support") && (
              <>
                <span className="highlight-gold">Thank you</span> for being an
                essential part of the{" "}
                <span className="highlight-orange">
                  Catastrophic Wildfire Prevention Consortium (CWPC)
                </span>{" "}
                community. We appreciate your support.
              </>
            )}
            {(successForm === "collab" ||
              successForm === "scorecard-collab") && (
              <>
                <span className="highlight-gold">Thank you</span> for contacting
                the{" "}
                <span className="highlight-orange">
                  Catastrophic Wildfire Prevention Consortium (CWPC)
                </span>
                ! We are grateful to have you as a valued member of our
                community. We are making a positive impact together and look
                forward to creating meaningful change with you.
              </>
            )}
            {(successForm === "feedback" ||
              successForm === "scorecard-feedback") && (
              <>
                We appreciate you taking the time to share your feedback. Your
                perspective is important, and we’re grateful for your
                contribution.
              </>
            )}
            {successForm === "notify" && (
              <>
                <span className="highlight-gold">Thank you</span> for submitting
                the form. We look forward to keeping you updated on the next
                showcase.
              </>
            )}
          </div>
          <div className="error-text">
            {successForm === "error" && (
              <>
                <span className="highlight-red">ERROR:</span> There was an issue
                submitting the form. Please try again. If the problem continues,
                contact us, and our team will gladly assist you.
              </>
            )}
          </div>
        </div>
      )}
    </>
  );

  return ReactDOM.createPortal(messageModal, document.body);
};

export default PopUpSuccessMessageModal;
